// extracted by mini-css-extract-plugin
export var banner = "_pn-0";
export var settingRow = "_pn-2";
export var titleIcon = "_pn-1";